<!-- Environment indicator for non-prod builds -->
<template>
  <div
    v-if="$q.platform.is.nativeMobile || isNonProdBuild"
    class="print-hide safe-area-top"
    :class="{ 'bg-white': applyBackground }"
    style="z-index: 1000000"
  >
    <!-- Hidden when the demo_mode flag is enabled -->
    <div
      v-if="isNonProdBuild && !demoModeEnabled"
      class="test-banner flex flex-center q-px-sm"
      :class="{ 'bg-teal-4 text-white': isDemoBuild, 'bg-amber-7 text-grey-8': isTestBuild }"
    >
      <span class="text-weight-bold">{{ isTestBuild ? 'TEST' : 'DEMO' }}</span>
    </div>
  </div>
</template>

<script setup>
const $q = useQuasar()
const route = useRoute()

const { featureFlags } = useFeatureFlagStore()
const demoModeEnabled = computed(() => featureFlags.demoMode?.enabled)

const isTestBuild = computed(() => {
  const appId = import.meta.env.VITE_APP_ID || ''
  return appId.includes('.test') || window.location.host.includes('test')
})

const isDemoBuild = computed(() => {
  const appId = import.meta.env.VITE_APP_ID || ''
  return appId.includes('.demo') || window.location.host.includes('demo')
})

const isNonProdBuild = computed(() => isTestBuild.value || isDemoBuild.value)

const applyBackground = computed(() => {
  return route.path !== '/' && !route.path.startsWith('/app/splash')
})
</script>

<style lang="scss" scoped>
.safe-area-top {
  height: $safe-area-inset-top;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
}

.test-banner {
  font-size: 8px;
  line-height: 12px;
  letter-spacing: 2px;
}

body:not(.native-mobile) .test-banner {
  max-width: 100px;
  margin: 0 auto;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

@media (min-width: $breakpoint-md-min) {
  .test-banner {
    font-size: 12px;
  }
}
</style>
